<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title" v-t="'message.title_edit_layer_information'">
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form label-width="150px" >
                        <div class="dialog-form-item">
                            <el-form-item prep="groupName" ref="groupName">
                                <div slot="label" style="text-align:left"><span v-t="'message.item_layerId'"></span> <span class="required" v-t="'message.item_required'"></span></div>
                                <el-input id="groupName" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.groupName.value"
                                     @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                     clearable @clear="InputCheckAll()"/>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.$data.disableButton" @click="saveChange()" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import charactercheck from './charactercheck.js';
import commonValidate from './common-validate.js';

export default {
    data() {
        return {
            inputForm: {
                groupName: { value: null,   isComposing: false }
            },
            disableButton: false,
        };
    },
    methods: {
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            let validateResult = commonValidate.objectId(this.$i18n, this.inputForm.groupName.value);
            if (validateResult.valid) {
                this.$refs[eventTargetId].clearValidate();
                this.disableButton = false;
            } else {
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
                this.disableButton = true;
            }
        },
        InputCheckAll() {
            this.inputCheck("groupName");
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },
        saveChange: function() {
            this.$emit('save', {newName: this.$data.inputForm.groupName.value })
        },
    },
    created: function() {
        this.inputForm.groupName.value = this.nodeInfo.name;
        this.disableButton = true;
    },
    props: ['nodeInfo' ]
}
</script scoped>

